module.exports = __webpack_public_path__ + "img/v1-0.1fa37500.png";